import { ProductDocument } from '@util/types/firestore/products';

export const useProductCard = (item: ProductDocument) => {
  const getSalePercent = () => {
    if (!item.on_sale) return 0;
    return Math.round(
      ((Number(item.og_price) - item.price) / Number(item.og_price)) * 100
    );
  };

  const soldOut = !(item.stock > 0);

  return {
    getSalePercent,
    soldOut,
  };
};
